import { dialApiFetch, isDialApiConfigured } from './client';

export interface TodayResponse {
  points: number;
  target: number;
  day_start: string;
}

const DEMO: TodayResponse = {
  points: 0,
  target: 30,
  day_start: new Date(new Date().setUTCHours(0, 0, 0, 0)).toISOString(),
};

export async function getToday(): Promise<TodayResponse> {
  if (!isDialApiConfigured) return DEMO;
  return dialApiFetch<TodayResponse>('/v1/me/today');
}
